import Testimonials6 from './Testimonials6'
export default Testimonials6
